import UserProfileService from './../services/UserProfile.service'

export class AdminOverride {
  override() {
    return UserProfileService.isA(['system-admin', 'internal-admin'], true)
  }
}
